define('components/decorators/compliance',[
    'jquery',
    '../util/reload-fragments',
    'components/decorator'
], function ($, reload, decorator) {

    var FORM_ERROR_HEADER = 'form-errors';

    $.extend(companyInfo.decorators, {

        'compliance': function () {

            var clearSortButton = $(".clear-sort-button");
            clearSortButton.hide();


            var body = $('body');

            var shouldHideBasisPage = JSON.parse(body.attr('shouldHideBasisPage'));
            var dateWarningMessage = body.attr('dateWarningMessage');

            var component = $(this);
            var complianceForms = component.find(".complianceForm");
            var peopleorg = $("#peopleorganisations");
            var pep = $("#pep");

            var peopleorgTab = $(".tab-link[href='#peopleorganisations']");
            var pepRadio = $('#people-radio');
            var organisationRadio = $('#organisations-radio');
            var activeForm = pepRadio.attr('checked').length ? 'pep' : 'organisation';

            var organisation = $("#organisation");

            var pepResults = $('#pepResults');
            var peopleorganisationsResults = $('#peopleorganisationsResults');
            var organisationResults = $("#organisationResults");
            var complianceIntro = $('#complianceIntro');
            var complianceWarning = $('#complianceWarning');

            var credits = $('[data-handler="tool-menu"]');

            var reloadType = component.data('reload-type');
            var reloadIds;
            var request;
            var MAX_LS_AGE = 1; // 1 day maximum item age in localStorage
            var searchResults = 'compliance-' + makeSearchId();
            var state = localStorage.getItem(searchResults) && JSON.parse(localStorage.getItem(searchResults));

            var reloadId;

            var sections;

            var userComesFromSearch = (state && state.userComesFromSearch) || false;

            clearOldLocalStorageItems();
            initHandlers();

            var shouldSeePersonsTab = function (state) {
                var returnVal = ((window.location.pathname === "/compliance/search/pep") ||
                (window.location.pathname === "/compliance/preparesearch/pep") ||
                (state && state.reloadId === 'compliance-results-pep'));

                if (shouldHideBasisPage) {
                    return returnVal || window.location.pathname === "/searchcompliance" || window.location.pathname.indexOf('/searchcompliance/persons') != -1;
                } else {
                    return returnVal;
                }
            };

            var shouldSeeOrganisationTab = function (state) {
                return (window.location.pathname === "/compliance/search/business")
                    || (window.location.pathname.indexOf('/searchcompliance/business') !== -1)
                    || (state && state.reloadId === 'compliance-results-organisations');
            };

            var userComesFromC6Page = function () {
                return document.referrer.match(/persons/) || document.referrer.match(/organisations/);
            };

            var userComesFromLinkInTopMenu = function () {
                return window.location.pathname === "/searchcompliance";
            };

            if (window.location.pathname === "/searchcompliance" && !userComesFromC6Page()) {
                reload.clearCache();
                userComesFromSearch = false;
                pepResults.innerHTML = '';
                organisationResults.innerHTML = '';
            }

            if (window.location.pathname === "/compliance/preparesearch/pep") {
                if (window.location.search && !userComesFromC6Page()) {
                    reload.clearCache();
                }
                userComesFromSearch = false;
            }

            else if (state && !userComesFromLinkInTopMenu) {
                if (window.location.pathname !== "/compliance/search/business" && window.location.pathname !== "/compliance/search/pep") {
                    reload.clearCache();
                    userComesFromSearch = false;
                }
            }

            function initHandlers() {
                var costArgreementCheckbox = activeForm === 'pep' ? $('#pep-cost-agreement') : $('#org-cost-agreement');
                costArgreementCheckbox.on('click', function() {
                    var submitButton = $('#' + activeForm).find('.submit');
                    this.checked ? submitButton.prop('disabled', false) : submitButton.prop('disabled', true);
                });
            }

            function scrollToResults(activeForm) {
                var animationDuration = 1000;
                var headerHeight = $('.header-wrapper').height();
                var padding = 10;
                var form = activeForm === 'pep' ? '#pepResults' : '#organisationResults';

                $('html').animate({
                    scrollTop: $(form).offset().top - headerHeight - padding
                }, animationDuration);
            }

            pepRadio.on('click', function() {
                activeForm = 'pep';
                credits.show();
                initHandlers();
                pep.removeClass('unselected-tab');
                organisation.addClass('unselected-tab');
            });

            organisationRadio.on('click', function () {
                activeForm = 'organisation';
                credits.show();
                initHandlers();
                organisation.removeClass('unselected-tab');
                pep.addClass('unselected-tab');
            });

            if (state && document.referrer.indexOf('/people') > -1) {
                var peopleTable = document.getElementById('pepResults');
                reload.clearCache();
                peopleTable.innerHTML = '';
                pepResults.innerHTML = '';
            }

            if (shouldSeePersonsTab(state)) {
                peopleorg.addClass('unselected-tab');
                pep.removeClass('unselected-tab');
                organisation.addClass('unselected-tab');

                peopleorgTab.removeClass('selected-link');
                pepRadio.click();
                complianceIntro.find('.peponly').show();
                // complianceIntro.find('.basiconly').hide();
                userComesFromSearch = true;
                credits.show();

            }
            else if (shouldSeeOrganisationTab(state)) {
                peopleorg.addClass('unselected-tab');
                pep.addClass('unselected-tab');
                organisation.removeClass('unselected-tab');

                peopleorgTab.removeClass('selected-link');
                organisationRadio.click();

                // complianceIntro.find('.basiconly').hide();
                userComesFromSearch = true;

            }
            else {
                userComesFromSearch = false;
                complianceIntro.find('.basiconly').show();
                credits.hide();
                peopleorgTab.addClass('selected-link');
            }

            if (state && window.location.pathname === "/searchcompliance") {
                reload.clearCache();
                userComesFromSearch = false;
            }

            complianceForms.on('submit', 'form', handleSubmit);

            $(window).on('popstate', function() { window.location.reload(); });

            function handlePostResponse(response, status, request) {
                if (request.getResponseHeader(FORM_ERROR_HEADER)) {
                    sections = reload.getSections('compliance-pep-form', ['pep-form', 'business-form']);
                    reload.replaceContent(response, sections);
                    initHandlers();
                    unsetLoading();
                }
                else {
                    setLoading();
                    sections = reload.getSections(reloadType, reloadIds);

                    reload.clearCache();
                    reload.replaceContent(response, sections);
                    userComesFromSearch = true;

                    changeUrlToCurrentSearch();

                    var searchId = makeSearchId();

                    addToLocalStorage('compliance-' + searchId, JSON.stringify({
                        response: response,
                        reloadType: reloadType,
                        reloadIds: reloadIds,
                        reloadId: reloadId,
                        userComesFromSearch: userComesFromSearch,
                        timeStamp: Date.now()
                    }));

                    initHandlers();
                    scrollToResults(activeForm);
                    unsetLoading();
                }
            }

            function handleSubmit(e) {
                e.preventDefault();
                e.stopImmediatePropagation();

                if (request) {
                    return;
                }

                setLoading();
                reloadIds = [];

                if (this.action.indexOf("pep") > -1) {
                    reloadId = 'compliance-results-pep';
                    reloadIds.push(pepResults.data('reload-id'));
                    reloadIds.push('compliance-warning');
                    reloadIds.push('pep-form');

                }
                else if (this.action.indexOf("business") > -1) {
                    reloadId = 'compliance-results-organisations';
                    reloadIds.push(organisationResults.data('reload-id'));
                    reloadIds.push('compliance-warning');
                    reloadIds.push('business-form');
                }

                else {
                    reloadId = 'compliance-results-basic';
                    reloadIds.push(peopleorganisationsResults.data('reload-id'));
                }

                reloadIds.push('compliance-credit-button-organisation');
                reloadIds.push('compliance-credit-button-pep');

                request = $.ajax({
                    url: this.action,
                    method: "get",
                    data: $(this).serializeArray(),
                    cache: false
                })
                    .done(handlePostResponse)
                    .fail(function () {
                        log("Failed submit request", arguments);
                        unsetLoading();
                        displayServerError();
                    });
            }

            function displayServerError() {
                var serverError = $('.compliance-search__server-error');
                serverError.show();
                $(window).one('click keypress', function () {
                    serverError.hide();
                });
            }

            function setLoading() {
                component.addClass('loading');
            }

            function unsetLoading() {
                component.removeClass('loading');
                request = null;
            }

            $(document).ready(function () {

                var birthDateInput = document.getElementById('birthDate');
                birthDateInput.oninvalid = function (event) {
                    if (event.target.validity.patternMismatch) {
                        event.target.setCustomValidity(dateWarningMessage);
                    }
                };

                birthDateInput.oninput = function (event) {
                    event.target.setCustomValidity('');
                };

                if (window.location.pathname === "/compliance/preparesearch/pep") {
                    if (peopleorgTab.hasClass("selected-link")) {
                        sections = reload.getSections(state.reloadType, state.reloadIds);
                        reload.replaceContent(state.response, sections);
                    }

                }
                else if (window.location.pathname === "/searchcompliance") {
                    if (shouldHideBasisPage) {
                        peopleorgTab.removeClass('selected-link');
                        reload.clearCache();
                        pepRadio.click();
                    } else {
                        credits.hide();
                        peopleorgTab.addClass('selected-link');
                        reload.clearCache();
                        peopleorgTab.click();
                    }
                }
                else {
                    var searchId = makeSearchId();
                    var newState = JSON.parse(localStorage.getItem('compliance-' + searchId));
                    if (newState) { // Make sure saved search is found
                        sections = reload.getSections(newState.reloadType, newState.reloadIds);
                        setTimeout(function() {
                            // Calling reload directly will cause decorators to run before this one is finished
                            // so we are delaying it to run after the first decorator run cycle
                            reload.replaceContent(newState.response, sections);
                            initHandlers();
                        }, 0);
                    } else {
                        initHandlers();
                    }
                }
            });

            // Clear old compliance searches from localStorage
            function clearOldLocalStorageItems() {
                var oldestSearches = getSavedSearches()
                    .filter(function(el) { // Filtering search older than one day
                        return isOld(el.timeStamp);
                    });
                if (oldestSearches.length) {
                    oldestSearches.forEach(function (el) { // Removing all old search from localStorage
                        localStorage.removeItem(el.key);
                    });
                }
            }

            // Check if creation date of localStorage item is older than maximum allowed age
            function isOld(creationDate) {
                var maxAge = new Date();
                maxAge.setDate(maxAge.getDate() - MAX_LS_AGE);
                return creationDate < maxAge;
            }

            // Returns saved compliance searches from localStorage in parsed format
            function getSavedSearches() {
                var searches = Object.keys(localStorage)
                    .filter(function(item) { // Getting all keys
                        return item.indexOf('compliance-') !== -1;
                    })
                    .map(function(el) { // Making array of parsed localStorage items
                        var parsed = JSON.parse(localStorage.getItem(el));
                        parsed.key = el;
                        return parsed;
                    });
                return searches;
            }

            function addToLocalStorage(key, item, savedSortedSearches) {
                try {
                    localStorage.setItem(key, item);
                } catch (e) {
                    // If localStorage save fails, presumably because there is not enough space, find and remove oldest saved compliance search, and than add new search again
                    if (e.name.length > 0) { // Not checking for QUOTA_EXCEEDED_ERR error name because it's different depending on browser
                        var savedSorted = savedSortedSearches || getSavedSearches()
                            .sort(function(a, b){
                                return a.timeStamp > b.timeStamp ? -1 : 1;
                            });
                        if (savedSorted.length) {
                            var oldest = savedSorted.pop();
                            localStorage.removeItem(oldest.key);
                            addToLocalStorage(key, item, savedSorted);
                        }
                    }
                }
            }

            // Returns input values based on current active form
            function getSearchTerms() {
                var searchTerms = activeForm === 'pep' ? {
                    firstName: $("[name='pepSearchParameters.name']").val(),
                    lastName: $("[name='pepSearchParameters.surname']").val(),
                    birthDate: $("[name='pepSearchParameters.birthDate']").val(),
                } : {
                    businessName: $("[name='businessSearchParameters.businessName']").val()
                };
                return searchTerms;
            }

            function hashCode(s) {
                var hash = 0,
                    l = s.length,
                    i,
                    c;
                if ( l === 0 ) {
                    return hash;
                }
                for ( i = 0; i < l; i++ ) {
                    c = s.charCodeAt( i );
                    hash = ((hash << 5) - hash) + c;
                    hash = hash & hash; // Convert to 32bit integer
                }
                return hash;
            }

            // Returns string which is used as a key to select item from localStorage
            function makeSearchId() {
                var searchTerms = getSearchTerms();
                var searchId = Object.keys(searchTerms).reduce(function(acc, curr) {
                    return acc += searchTerms[curr];
                }, "");

                return hashCode(searchId);
            }

            // Change url after search  so that page refresh works with localStorage
            function changeUrlToCurrentSearch() {
                var isPep = activeForm === 'pep';
                var searchTerms = getSearchTerms();
                var urlBase = window.location.protocol + '//' + window.location.host + '/' + 'compliance/search' + '/' + (isPep ? 'pep?' : 'business?');
                var params = 'cache=true&' + (isPep ?
                    'pepSearchParameters.name=' + encodeURIComponent(searchTerms.firstName) + '&' +
                    'pepSearchParameters.surname=' + encodeURIComponent(searchTerms.lastName) + '&' +
                    'pepSearchParameters.birthDate=' + encodeURIComponent(searchTerms.birthDate) + '&' :

                    'businessSearchParameters.businessName=' + encodeURIComponent(searchTerms.businessName));
                history.pushState(null, null, urlBase + params);
            }
        },


    });

    function log(message, data) {
        if (console && console.log) {
            console.log(message, data);
        }
    }
});

